<app-loader [loading]="isLoading" [overlay]="true"></app-loader>

<ng-container *ngTemplateOutlet="header"></ng-container>

<mat-tab-group class="top-spacer-negative" mat-align-tabs="left" animationDuration="0ms">
  <mat-tab [label]="'general.api_venues_tab_general_info' | translate">
      <div class="with-footer">
        <div class="flex flex-column">
          <div class="card-grid grid-2 grid-column-mobile">
            <div>
              <ng-container *ngTemplateOutlet="generalInfo"></ng-container>
              <ng-container *ngTemplateOutlet="venueOwner"></ng-container>
              <ng-container *ngTemplateOutlet="description"></ng-container>
              <ng-container *ngTemplateOutlet="address"></ng-container>
            </div>
            <div>
              <ng-container *ngIf="venue.id && (!isView || venue.locationLogo || venue.locationImage)">
                <ng-container *ngTemplateOutlet="locationLogo"></ng-container>
                <ng-container *ngTemplateOutlet="locationImage"></ng-container>
              </ng-container>
              <ng-container *ngTemplateOutlet="contactPersons"></ng-container>
            </div>
          </div>
        </div>
      </div>
  </mat-tab>
  <mat-tab [label]="'general.api_venues_tab_audit_log' | translate" *ngIf="canSeeAuditLogs && isView">
    <div class="with-footer">
        <ng-container *ngTemplateOutlet="auditLogsTemplate"></ng-container>
    </div>
  </mat-tab>
</mat-tab-group>
<app-footer [leftContent]="leftContent" [noColumn]="true">
  <div class="flex decreased-column-gap">
    <ng-container *ngTemplateOutlet="venueContextMenu"></ng-container>
    <button mat-flat-button color="primary" *ngIf="isCreate" [disabled]="!isValid" (click)="isValid && create()">
      {{'general.api_venues_form_create' | translate}}
    </button>
    <button mat-flat-button color="primary" *ngIf="isCopy" [disabled]="!isValid" (click)="isValid && create()">
      {{'general.api_venues_form_copy' | translate}}
    </button>
    <button mat-flat-button color="primary" *ngIf="isEdit" [disabled]="!isValid" (click)="isValid && update()">
      {{'general.api_venues_form_save' | translate}}
    </button>
  </div>
</app-footer>

<ng-template #leftContent>
  <div>
    <button mat-button (click)="isView || isCreate ? backToList() : viewMode()">
      {{(isView || isCreate ? 'general.api_general_back_to_list' : 'general.api_venues_form_cancel') | translate}}
    </button>
  </div>
</ng-template>

<ng-template #venueContextMenu>
  <ng-container *ngIf="(authService.hasPublicVenuesAdminPrivilege || isPrivateVenueOwner(venue)) && !isCopy && !isCreate">
    <button mat-button class="icon-button input-button" [matMenuTriggerFor]="venueActionMenu">
      <mat-icon class="svg-icon" [svgIcon]="'menu_vert'"></mat-icon>
    </button>
    <mat-menu #venueActionMenu="matMenu">
      <button mat-menu-item (click)="copy()">
        <mat-icon class="svg-icon" [svgIcon]="'copy'"></mat-icon>
        <span>{{ 'general.api_venues_copy' | translate }}</span>
      </button>
      <button mat-menu-item (click)="editMode()" *ngIf="!isEdit">
        <mat-icon class="svg-icon" [svgIcon]="'pencil'"></mat-icon>
        <span>{{ 'general.api_venues_edit' | translate }}</span>
      </button>
    </mat-menu>
  </ng-container>
</ng-template>

<ng-template #header>
  <h1 [innerHTML]="getDialogTitle | translate"></h1>
  <div class="flex flex-wrap decreased-margin">
    <div class="heading-3 top-spacer-negative-x2">
      <span class="badge" *ngIf="isView" [ngClass]="{'success': isActive, 'warning': !isActive}">
        {{ 'general.api_venues_status_' + venue.status | translate }}
      </span>
      <span class="badge accent" *ngIf="venue.isYbo" [ngClass]="{'left-spacer': isView}">
        {{'general.api_venues_legacy_venue' | translate}}
      </span>
      <span class="badge accent" *ngIf="isView && venue.type" [ngClass]="{'left-spacer': isView}">
        {{'general.api_venues_type_' + venue.type | translate}}
      </span>
      <span class="badge left-spacer" *ngIf="isView && venue.ownerConsentRequired">
        {{ 'general.api_venues_location_requires_consent' | translate }}
      </span>
    </div>
  </div>
</ng-template>

<ng-template #address>
  <mat-card appearance="outlined" class="decreased-margin">
    <app-section-header [title]="'general.api_venues_table_address_title'" [tooltip]="!isView ? 'general.api_venues_table_address_info' : null"
                        [required]="!isView"></app-section-header>
    <div class="flex flex-column">
      <div class="card-grid grid-2 grid-column-mobile">
        <div>
          <div class="flex flex-column">
            <ng-container *ngIf="!isView">
              <app-google-autocomplete (addressSelected)="fillLocationData($event, true)" [hideMap]="true" [address]="formattedAddress"></app-google-autocomplete>
              <hr class="extra-slim">
            </ng-container>
            <app-label-value [label]="'general.api_venues_table_country'" [value]="countryService.getCountryTranslationKey(venue.countryCode)"></app-label-value>
            <app-label-value [label]="'general.api_venues_table_county'" [value]="venue.county"></app-label-value>
            <app-label-value [label]="'general.api_venues_table_city'" [value]="venue.city"></app-label-value>
            <app-label-value [label]="'general.api_venues_table_address'" [value]="venue.address"></app-label-value>
            <button mat-button class="input-button align-self-start" *ngIf="!isView && isNotEmptyVenue" (click)="clearVenue()">
              <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
              <ng-container>{{ 'general.api_venues_clear_location' | translate }}</ng-container>
            </button>
          </div>
        </div>
        <div>
          <app-google-autocomplete [readOnly]="isView" (addressSelected)="fillLocationData($event)" [addressCleared]="addressCleared" [address]="formattedAddress" [hideSearch]="true"></app-google-autocomplete>
        </div>
      </div>
    </div>
  </mat-card>
</ng-template>

<ng-template #generalInfo>
  <mat-card appearance="outlined" class="decreased-margin">
    <h3 class="bold">{{ 'general.api_venues_form_info' | translate }}</h3>
    <div class="flex flex-column" *ngIf="!isView">
      <!-- Name -->
      <app-text-input [label]="'general.api_venues_table_name'" [max]="VENUE_NAME_MAX_LENGTH"
                      [(value)]="venue.name" (valueChange)="venueNameChanged = true; updateLocationChangeState(false)"
                      [customErrorFunction]="hasVenueNameError()" [customError]="venueNameError" [required]="true"></app-text-input>
      <div class="flex flex-wrap flex-column-mobile">
        <!-- Venue type -->
        <mat-form-field *ngIf="authService.hasPublicVenuesAdminPrivilege && isCreate" appearance="outline" class="no-hint">
          <mat-label>{{ 'general.api_venues_table_type' | translate }}</mat-label>
          <mat-select [(ngModel)]="venue.type" [ngModelOptions]="{standalone: true}" [required]="true" (ngModelChange)="venue.ownerConsentRequired = false">
            <mat-option *ngFor="let type of venueTypes" [value]="type">
              {{ 'general.api_venues_type_' + type | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <!-- Is active -->
        <mat-slide-toggle [(ngModel)]="isActive" [ngModelOptions]="{standalone: true}">
          {{ 'general.api_venues_form_is_active' | translate }}
        </mat-slide-toggle>
        <!-- Is consent required -->
        <mat-slide-toggle *ngIf="venue.type === VenueType.Public" [(ngModel)]="venue.ownerConsentRequired" [ngModelOptions]="{standalone: true}">
          {{ 'general.api_venues_form_is_consent_required' | translate }}
        </mat-slide-toggle>
      </div>
    </div>
    <hr class="slim">
    <div class="flex flex-column">
      <div class="flex flex-grow flex-wrap flex-column-mobile">
        <!-- Website -->
        <app-text-input *ngIf="!isView" [type]="TextInputType.Link" [label]="'general.api_venues_table_website'"
                        [(value)]="venue.website" [max]="VENUE_WEBSITE_MAX_LENGTH"></app-text-input>
        <div *ngIf="isView && venue.website">
          <app-label-value [label]="'general.api_venues_table_website'" [value]="venue.website" [link]="true" [openTab]="true"></app-label-value>
        </div>
        <!-- Max capacity -->
        <app-numeric-input *ngIf="!isView" [label]="'general.api_venues_form_max_capacity'"
                           [(value)]="venue.maxCapacity"></app-numeric-input>
        <app-label-value *ngIf="isView" [label]="'general.api_venues_form_max_capacity'" [value]="venue.maxCapacity"></app-label-value>
      </div>
    </div>
  </mat-card>
</ng-template>

<ng-template #venueOwner>
  <mat-card appearance="outlined" class="decreased-margin">
    <h3 class="break-word bold">{{'general.api_venues_form_venue_owner_title' | translate}}</h3>
    <div class="flex flex-column">
      <app-scroll-load label="general.api_venues_form_venue_owner" *ngIf="!isView" [disabled]="venue.type === VenueType.Private"
                       [customQuery]="legalPersonService.setPageableVenueQuery"
                       [searchService]="legalPersonService" [scrollLoad]="legalPersonScrollLoad"
                       [displayOption]="legalPersonService.displayScrollLoadOptionNameAndCountryCode"
                       [displaySelection]="legalPersonService.displayScrollLoadSelectionNameAndCountryCode"
                       [(selectedObjectId)]="venue.ownerLegalPersonId"></app-scroll-load>
      <app-label-value *ngIf="isView" [label]="'general.api_venues_form_venue_owner'"
                       [value]="legalPersonService.displayScrollLoadSelectionNameAndCountryCode(this.legalPersonScrollLoad.object)"></app-label-value>
    </div>
  </mat-card>
</ng-template>

<ng-template #description>
  <mat-card appearance="outlined" class="decreased-margin">
    <ng-container *ngIf="!isView">
      <h3 class="bold">{{'general.api_venues_form_description' | translate}}</h3>
      <app-lang-tabs [fields]="fields" [primaryRequired]="false"
                     [baseItem]="venue" [(selectedLanguages)]="selectedLanguages" (valueChanges)="syncVenueDescriptions()"></app-lang-tabs>
    </ng-container>
    <app-translation-tabs *ngIf="isView"
                          [title]="'general.api_venues_form_description'" [header]="true"
                          [htmlValues]="false" [translationValues]="venue.descriptions"></app-translation-tabs>
  </mat-card>
</ng-template>

<ng-template #locationLogo>
  <mat-card appearance="outlined" class="decreased-margin" *ngIf="!isView || venue.locationLogo">
    <app-s3-uploader *ngIf="!isView"
                     [title]="'general.api_venues_form_location_logo'"
                     [(model)]="venue.locationLogo"
                     [id]="venue.id"
                     [ownerCentreId]="venue.ownerCentreId" [ratio]="S3UploaderRatios.Logo"
                     [button]="'general.api_venues_form_location_logo_add'" [hint]="'general.api_venues_form_location_logo_add_hint'"
    ></app-s3-uploader>
    <app-label-value *ngIf="isView && venue.locationLogo"
                     [label]="'general.api_venues_form_location_logo'" [labelClass]="'heading-3 bold'" [withMargin]="true"
                     [template]="locationLogoTemplate"></app-label-value>
    <ng-template #locationLogoTemplate>
      <app-s3-downloader
        [model]="venue.locationLogo" [type]="S3UploaderTypes.Venue"
        [ownerCentreId]="venue.ownerCentreId" [ownerId]="venue.id" [ratio]="S3UploaderRatios.Logo"
      ></app-s3-downloader>
    </ng-template>
  </mat-card>
</ng-template>

<ng-template #locationImage>
  <mat-card appearance="outlined" class="decreased-margin" *ngIf="!isView || venue.locationImage">
    <app-s3-uploader *ngIf="!isView"
                     [title]="'general.api_venues_form_location_image'"
                     [(model)]="venue.locationImage"
                     [id]="venue.id" [multipleRatios]="true"
                     [ownerCentreId]="venue.ownerCentreId" [ratio]="S3UploaderRatios.Modern"
                     [button]="'general.api_venues_form_location_image_add'" [hint]="'general.api_venues_form_location_image_add_hint'"
    ></app-s3-uploader>
    <app-label-value *ngIf="isView && venue.locationImage"
                     [label]="'general.api_venues_form_location_image'" [labelClass]="'heading-3 bold'" [withMargin]="true"
                     [template]="locationImageTemplate"></app-label-value>
    <ng-template #locationImageTemplate>
      <app-s3-downloader
        [model]="venue.locationImage" [type]="S3UploaderTypes.Venue"
        [ownerCentreId]="venue.ownerCentreId" [ownerId]="venue.id" [ratio]="S3UploaderRatios.Modern"
        [noBorder]="true"
      ></app-s3-downloader>
    </ng-template>
  </mat-card>
</ng-template>

<ng-template #contactPersons>
  <mat-card appearance="outlined" class="decreased-margin">
    <div class="flex space-between">
      <app-section-header [title]="'general.api_venues_form_contact_persons'"></app-section-header>
      <div *ngIf="!isView">
        <app-link [link]="'general.api_venues_form_add_contact_person'" [icon]="'plus'" (linkClicked)="addContactPerson()"/>
      </div>
    </div>
    <div class="top-spacer" *ngIf="!venue.contactPersons?.length && isView">
      <app-info-message [message]="'general.api_venues_no_contact_persons'"></app-info-message>
    </div>
    <ng-container *ngIf="venue.contactPersons?.length">
      <ng-container *ngIf="utilService.isMobile && venue.contactPersons[0].name">
        <hr class="slim top-spacer mobile">
        <div class="mobile">
          <ng-container *ngFor="let contactPerson of venue.contactPersons; let even = even; let index = index">
            <div class="listing-block" *ngIf="contactPerson.name">
              <div class="header-block flex flex-grow space-between bottom-spacer">
                <div>
                  <a class="heading-5 no-margin break-all bold" [ngClass]="{'link': !isView}"
                     (click)="$event.stopPropagation(); !isView && editContactPerson(index)">
                    {{ contactPerson.name }}
                  </a>
                </div>
                <div class="white-space-no-wrap no-grow no-min-width" *ngIf="!isView">
                  <div class="flex flex-end decreased-margin">
                    <button mat-button class="input-button icon-button" (click)="editContactPerson(index)">
                      <mat-icon class="svg-icon" [svgIcon]="'pencil'"/>
                    </button>
                    <button mat-button class="input-button icon-button" (click)="removeContactPerson(index)">
                      <mat-icon class="svg-icon" [svgIcon]="'trash'"/>
                    </button>
                  </div>
                </div>
              </div>
              <table class="mobile-max-width bottom-spacer">
                <tbody>
                  <tr *ngIf="contactPerson.email">
                    <td>{{ 'general.api_venues_form_contact_person_email' | translate }}</td>
                    <td class="align-right break-all">{{ contactPerson.email }}</td>
                  </tr>
                  <tr *ngIf="contactPerson.phoneNr">
                    <td>{{ 'general.api_venues_form_contact_person_phone' | translate }}</td>
                    <td class="align-right">{{ contactPerson.phoneNr | phoneNumber }}</td>
                  </tr>
                </tbody>
              </table>
              <hr class="no-margin">
            </div>
          </ng-container>
        </div>
      </ng-container>
      <table class="report-table desktop top-spacer" *ngIf="!utilService.isMobile && venue.contactPersons[0].name">
        <thead>
          <tr>
            <th>{{ 'general.api_venues_form_contact_person_name' | translate }}</th>
            <th>{{ 'general.api_venues_form_contact_person_email' | translate }}</th>
            <th>{{ 'general.api_venues_form_contact_person_phone' | translate }}</th>
            <th class="min-width" *ngIf="!isView">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let contactPerson of venue.contactPersons; let index = index">
            <tr *ngIf="contactPerson.name">
              <td>
                <a class="no-margin break-all bold" [ngClass]="{'link': !isView}" (click)="$event.stopPropagation(); !isView && editContactPerson(index)">
                  {{ contactPerson.name }}
                </a>
              </td>
              <td><div class="break-all">{{ contactPerson.email || '-' }}</div></td>
              <td>{{ contactPerson.phoneNr ? (contactPerson.phoneNr | phoneNumber) : '-' }}</td>
              <td class="align-right min-width" *ngIf="!isView">
                <div class="flex flex-end decreased-margin">
                  <button mat-button class="input-button icon-button" (click)="editContactPerson(index)">
                    <mat-icon class="svg-icon" [svgIcon]="'pencil'"/>
                  </button>
                  <button mat-button class="input-button icon-button" (click)="removeContactPerson(index)">
                    <mat-icon class="svg-icon" [svgIcon]="'trash'"/>
                  </button>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </ng-container>
  </mat-card>
</ng-template>

<ng-template #modalTemplate let-data>
  <app-dialog-header [title]="data.title" [withConfirm]="true" (closed)="data.closeModal()" [tooltip]="data.titleTooltip"></app-dialog-header>
  <mat-dialog-content>
    <div class="flex flex-column flex-column-mobile bottom-spacer-x2">
      <ng-container *ngTemplateOutlet="data.template; context: {data: data}"></ng-container>
    </div>
  </mat-dialog-content>
  <app-dialog-footer [dialogActions]="modalButtonsTemplate"></app-dialog-footer>
  <ng-template #modalButtonsTemplate>
    <button mat-button (click)="data.closeModal()">
      {{ 'general.api_general_close' | translate }}
    </button>
    <button mat-stroked-button color="primary" *ngIf="data.primaryButton" (click)="data.primaryAction(data)"
            [disabled]="data?.primaryButtonDisabled && data.primaryButtonDisabled()">
      {{ data.primaryButton | translate }}
    </button>
    <button mat-stroked-button color="primary" *ngIf="data.secondaryButton" (click)="data.secondaryAction(data)"
            [disabled]="data?.secondaryButtonDisabled && data.secondaryButtonDisabled()">
      {{ data.secondaryButton | translate }}
    </button>
    <button mat-flat-button color="primary" (click)="data.closeModal(data.model)" *ngIf="data.saveButton"
            [disabled]="!data.isValid()">
      {{ data.saveButton | translate }}
    </button>
  </ng-template>
</ng-template>

<ng-template #contactPersonModalContent let-data="data">
  <app-text-input [label]="'general.api_venues_form_contact_person_name'" [(value)]="data.model.name"
                  [max]="data.nameMaxLength" [required]="true"></app-text-input>
  <app-text-input [type]="TextInputType.Email" [label]="'general.api_venues_form_contact_person_email'" [(value)]="data.model.email"
                  [customErrorFunction]="data.validations.isEmailExist()" [customError]="'general.api_venues_form_contact_person_email_already_exist'"
                  [max]="data.emailMaxLength" [required]="true"></app-text-input>
  <app-phone-input [(phoneNr)]="data.model.phoneNr" [label]="'general.api_venues_form_contact_person_phone'"></app-phone-input>
</ng-template>

<ng-template #auditLogsTemplate>
  <mat-card>
    <audit-log-table [pageData]="auditLogPage" [(page)]="auditPageNumber" (pageChange)="getAuditLogs()"></audit-log-table>
  </mat-card>
</ng-template>
